import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CurrencyPipe, DatePipe} from "@angular/common";

@Component({
    selector: 'fund-information',
    templateUrl: './fund-information.component.html',
    styleUrls: ['./fund-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class FundInformationComponent {
  @Input('fund') fund: any;
  @Input('statuses') statuses: any;
  @Input('types') types: any;
  @Input('readOnly') readOnly: boolean = false;
  @Input('isCertificated') isCertificated:boolean = false;
  @Output('save') saveForm: EventEmitter<any> = new EventEmitter<any>()
  @Input('permissions') permissions: any;
  public editMode: boolean = false;
  public selectedType:any;
  public selectedStatus:any;
  private legalEntityId:string;
  private managingMemberId:string | null = null;
  public infoGroup: FormGroup = new FormGroup({
    name: new FormControl(''),
    legal_name: new FormControl(''),
    ein: new FormControl(''),
    status: new FormControl(''),
    ic_code: new FormControl(''),
    type: new FormControl(''),
    mngMember: new FormControl(''),
    totalCommittedEquity: new FormControl('', Validators.pattern("^[0-9]*$")),
    closingDate: new FormControl(''),
    commitments_required: new FormControl<boolean|null>(null)
  });

  public getLegalName(fund:any){
    let legalName = null
    if(fund.legal_name === null){
      let ownedEntity = fund.ownedEntities.find((entity:any) => {
        return entity.ownedEntityAttributes.filter((attr:any) => attr.ownedEntityType.name === 'Limited Liability Corporation').length > 0
      })
      if(ownedEntity){
        legalName = ownedEntity.name;
        this.legalEntityId = ownedEntity.id
      }
    } else {
      legalName = fund.legal_name;
    }
    return legalName;
  }

  public getManagingMember(fund:any){
    let memberName = null;
    let ownedEntity = fund.ownedEntities.find((entity:any) => {
      return entity.ownedEntityAttributes.filter((attr:any) => attr.ownedEntityType.name === 'Special Purpose Entity').length > 0
    })
    if(ownedEntity){
      memberName = ownedEntity.name
      this.managingMemberId = ownedEntity.id
    }
    return memberName
  }

  public getFundStatus(fund:any){
    return fund.fundStatuses[0].status.name
  }

  public toggleEdit(){
    this.editMode = !this.editMode;
    if(this.editMode){
      this._setEditValues()
    }
  }

  public save(){
    let obj = {
      legal_entity_id: this.legalEntityId,
      managing_member_id: this.managingMemberId,
      ...this.infoGroup.value
    }

    this.saveForm.emit(obj)
    this.toggleEdit()
  }

  private _setEditValues(){
    this.infoGroup.controls['name'].setValue(this.fund.name)
    this.infoGroup.controls['legal_name'].setValue(this.getLegalName(this.fund))
    this.infoGroup.controls['ein'].setValue(this.fund.ein)
    this.infoGroup.controls['ic_code'].setValue(this.fund.ic_code)
    this.selectedStatus = this.statuses.find((status:any) => status.name === this.fund.fundStatuses[0].status.name)
    this.infoGroup.controls['status'].setValue(this.selectedStatus.id)
    this.selectedType = this.types.find((type:any) => type.name == this.fund.fundType.name);
    this.infoGroup.controls['type'].setValue(this.selectedType.id)
    this.infoGroup.controls['mngMember'].setValue(this.getManagingMember(this.fund))
    this.infoGroup.controls['totalCommittedEquity'].setValue(this.fund.invested_equity)
    let date = this.fund.close_date == null ? null : new Date(this.fund.close_date.split("-").join("/"))
    this.infoGroup.controls['closingDate'].setValue(date)
    this.infoGroup.controls['commitments_required'].setValue(this.fund.commitments_required)
  }

}
